import request from "@/utils/request";

//1,获取列表
export function getWorkgroups(data){
    return request({
        url:'/admin/getWorkgroups',
        data:data,
        method:'get'
    })
}
//2,添加
export function addWorkgroup(data){
    return request({
        url:'/admin/addWorkgroup',
        data:data,
        method:'post'
    })
}
//3,编辑
export function updateWorkgroup(data){
    return request({
        url:'/admin/updateWorkgroup',
        data:data,
        method:'post'
    })
}



//删除
export function removeWorkgroup(data){
    return request({
        url:'/admin/removeWorkgroup',
        data:data,
        method:'post'
    })
}
//查询单个分组详情
export function getWorkgroupDetail(data){
    return request({
        url:'/admin/getWorkgroupDetail',
        data:data,
        method:'get'
    })
}
//添加专家到分组
export function addExpertToWorkgroup(data){
    return request({
        url:'/admin/addExpertToWorkgroup',
        data:data,
        method:'post'
    })
}
//删除专家到分组
export function removeExpertFromWorkgroup(data){
    return request({
        url:'/admin/removeExpertFromWorkgroup',
        data:data,
        method:'post'
    })
}
//添加作品到分组
export function addWorkToWorkgroup(data){
    return request({
        url:'/admin/addWorkToWorkgroup',
        data:data,
        method:'post'
    })
}
//删除作品到分组
export function removeWorkFromWorkgroup(data){
    return request({
        url:'/admin/removeWorkFromWorkgroup',
        data:data,
        method:'post'
    })
}

